import React, { Component } from 'react';
import {
  Carousel,
  UploadImageModal,
  UploadVideoModal,
  UploadDocumentModal,
  Loading,
  UnitsModal
} from "common-import/custom";

import v from 'voca';
import moment from 'moment'
import { isEqual, isEmpty } from 'lodash';
import { MobXHelper, Request, VarHelper } from "common-import/helpers";
import { inject, observer } from "mobx-react";
import { HOST } from "common-import/constants";
import {Link} from "react-router-dom";

const defaultImage = 'http://jimenezylievanoabogados.com/en/wp-content/themes/jimenezylievanoabogados/images/no_image_profile.jpg';

const propertyBidding = [
  "name",
  "typeOfBid",
  "bidOpenTime",
  "bidCloseTime",
  "allowAlternativeBids",
  "allowSealedBids",
  "expectTypeOfContractor",
  "expectCountryOfContractor",
  "expectCityOfContractor",
  "expectDistrictOfContractor",
  "expectExperienceContractor",
  "expectRatingOfContractor",
  "expectRevenueOfContractor",
  "expectUnitRevenueOfContractor",
  "expectOtherRequirements",
  // "documents",
  // "works",
  // "materials",
  "preferredCurrency",
  // "invitedEmails",
  // "projectId",
];

@inject("biddingCategoryStore", "userStore", "masterStore", "routeStore") @observer
export default class BiddingDetail extends Component {

  constructor(props) {
    super(props);
    this.state = {
      bidding: {},
      current: {},
      creator: {},
      enableEdit: false,
      isSaving: false,
      isLoading: true,
      isApproving: false,
      isDeleting: false,
      openImageModal: false,
      openVideoModal: false,
      openDocumentModal: false,
      openUnitsModal: false,
      unitSelected: {},
    };

    this.handleEnableEdit = this.handleEnableEdit.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
  }

  async componentDidMount() {
    await this.props.userStore.onReady();
    await this.getBiddingDetail();
    this.setState({isLoading: false});
  }

  handleEnableEdit = (e) => {
    e.preventDefault();
    this.setState({ enableEdit: true })
  };

  cancelEdit = (e) => {
    e.preventDefault();
    const { bidding, current } = this.state;
    if (!isEqual(current, bidding)) {
      if (!window.confirm('Are you sure want to cancel the changes?')) {
        return;
      }
      this.setState({
        current: VarHelper.cloneDeep(bidding),
      });
    }
    this.setState({ enableEdit: false });
  };

  formatPayload = (data) => {
    const { userStore } = this.props;
    let copy;

    const typeFormat = {
      typeDate: ["bidOpenTime", "bidCloseTime"],
      typeBoolean: ["allowAlternativeBids", "allowSealedBids"],
      typeArray: ["documents", "listImages", "invitedEmails", "materials", "works"],
      typeNumber: ["expectExperienceContractor", "expectRatingOfContractor", "expectRevenueOfContractor"],
      typeString: ["id", "updateById", "updateByType", "name", "typeOfBid", "expectTypeOfContractor", "expectCountryOfContractor", "expectCityOfContractor", "expectDistrictOfContractor", "expectUnitRevenueOfContractor", "expectOtherRequirements", "preferredCurrency", "projectId"],
    };

    let keyList = [];
    for (let key in typeFormat) {
      keyList = [...keyList, ...typeFormat[key]];
    }

    copy = VarHelper.copyObjectWithKey(keyList, data);
    copy = Object.assign({}, copy, {
      "updateById": userStore.userData.id,
      "updateByType": 'project',
    });

    return VarHelper.formatValueByType(copy, typeFormat);
  };

  saveChanges = async () => {
    const { biddingCategoryStore, match } = this.props;
    const { current } = this.state;
    const payload = this.formatPayload(current);

    this.setState({ isSaving: true });
    const res = await biddingCategoryStore.update(payload);
    this.setState({ isSaving: false });

    if (!!res.error) {
      return window.toast.error('Updated failure: ' + JSON.stringify(res.error));
    }

    const resApprove = await biddingCategoryStore.approve({ id: match.params.id, approved: true });
    if (!resApprove.error) {
      res.data.approved = 1;
    }

    this.setState({
      bidding: VarHelper.cloneDeep(res.data),
      current: VarHelper.cloneDeep(res.data),
    });

    return window.toast.info('Updated successfully.');
  };

  getBiddingDetail = async () => {
    const { biddingCategoryStore, match } = this.props;
    const bidding = await biddingCategoryStore.getBiddingDetail(match.params.id);
    this.setState({
      bidding: VarHelper.cloneDeep(bidding),
      current: VarHelper.cloneDeep(bidding),
    });
    await this.getUserDetailById(bidding.createdByUserId);
  };

  getUserDetailById = async (id = 123) => {
    const { userStore } = this.props;
    const creator = await userStore.getUserDetailById(id);
    this.setState({ creator: creator.data });
  };

  approveBidding = async e => {
    !!e && e.preventDefault();
    const { biddingCategoryStore, match } = this.props;
    const { current } = this.state;
    const continueApprove = window.confirm("Are you sure want to APPROVE this bidding?");
    if (continueApprove) {
      this.setState({isApproving: true});
      let result = await biddingCategoryStore.approve({ id: match.params.id, approved: true });
      this.setState({isApproving: false});
      if (!!result.error) {
        return window.toast.error("Somethings came wrong, please try it again. " + JSON.stringify(result.error));
      }
      current.approved = 1;
      this.setState({
        bidding: current,
        current,
      });
      return window.toast.info("APPROVED successfully!");
    }
  };

  deleteBidding = async (e) => {
    !!e && e.preventDefault();
    const { biddingCategoryStore, userStore } = this.props;
    const { current } = this.state;
    const payload = {
      id: current.id,
      projectId: current.projectId,
      deleteById: userStore.userData.id,
      deleteByType: 'project',
    };
    const continueDelete = window.confirm("Are you sure want to DELETE this bidding?");
    if (continueDelete) {
      this.setState({isDeleting: true});
      let result = await biddingCategoryStore.delete(payload);
      this.setState({isDeleting: false});
      if (!!result.error) {
        return window.toast.error("Failed: " + JSON.stringify(result.error));
      }
      window.toast.info("DELETED successfully!");
      this.props.history.goBack();
    }
  };

  renderApprove = () => {
    const {isApproving, isDeleting} = this.state;
    const { approved } = this.state.current;
    if (approved === undefined || approved === "" || approved === true || approved === 1) {
      return (
        <div className="approve-request-section">
          <button className="btn btn-sm btn-danger" disabled={isDeleting} onClick={e => this.deleteBidding(e)}>
            <i className="fa fa-dot-circle-o"> </i> {isDeleting ? 'Deleting...':'Delete'}</button>
        </div>
      )
    }
    return (
      <div className="approve-request-section">
        <button className="btn btn-sm btn-primary" disabled={isApproving} onClick={e => this.approveBidding(e)}>
          <i className="fa fa-dot-circle-o"> </i> {isApproving ? 'Approving...':'Approve'}</button>
        <button className="btn btn-sm btn-danger" disabled={isDeleting} onClick={e => this.deleteBidding(e)}>
          <i className="fa fa-dot-circle-o"> </i> {isDeleting ? 'Deleting...':'Delete'}</button>
      </div>
    )
  };

  renderEditForm = () => {
    const {
      toValue,
      toSelectData,
      country, city, district,
      contractor_type,
      project_bidding_scope_name,
      project_bidding_scope_works,
      project_bidding_scope_materials,
    } = this.props.masterStore;

    const propMaster = {
      name: project_bidding_scope_name,
      expectTypeOfContractor: contractor_type,
      expectCountryOfContractor: country,
    };

    const renderOptions = (prop) => {
      let arr = [];

      if (["allowAlternativeBids", "allowSealedBids"].indexOf(prop) !== -1) {
        arr = [
          { id: 1, label: 'Yes', value: true },
          { id: 0, label: 'No', value: false },
        ]
      } else if (prop === "typeOfBid") {
        arr = [
          { id: 'private', label: 'Private', value: 'private' },
          { id: 'public', label: 'Public', value: 'public' },
        ]
      } else if (prop === "preferredCurrency") {
        arr = [
          { id: 'USD', label: 'USD', value: 'USD' },
          { id: 'VND', label: 'VND', value: 'VND' },
        ]
      } else {
        arr = toSelectData(propMaster[prop]);
      }

      arr = [{id: '', value: '', label: ''}, ...arr];

      return arr.map((item) => {
        return <option key={item.id + item.value} value={item.id}>
          {item.label}
        </option>
      })
    };

    return (
      <form className="block-content">
        <h4 className="block-content__title">
          <i className="fa fa-pencil" aria-hidden="true"> </i>
          Edit project information
        </h4>
        <div className="row">
          {
            propertyBidding.map((property, index) => {
              let element;
              if (["allowAlternativeBids", "allowSealedBids", "name", "typeOfBid", "expectTypeOfContractor", "expectCountryOfContractor", "preferredCurrency"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}</label>
                  <select
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    defaultValue={this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  >
                    {renderOptions(property)}
                  </select>
                </div>
              } else if (["bidOpenTime", "bidCloseTime"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)} (mm/dd/yyyy):</label>
                  <input
                    type="text"
                    className="form-control"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    defaultValue={moment(this.state.current[property]).format('L')}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else if (["expectExperienceContractor", "expectRatingOfContractor", "expectRevenueOfContractor"].indexOf(property) !== -1) {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <input
                    type="number"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    defaultValue={this.state.current[property] === null ? '' : this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              } else {
                element = <div className="position-relative form-group">
                  <label htmlFor={"nf-" + property}>{v.capitalize(property)}:</label>
                  <input
                    type="text"
                    id={"nf-" + property}
                    name={"nf-" + property}
                    className="form-control"
                    defaultValue={this.state.current[property] === null ? '' : this.state.current[property]}
                    onChange={e => this.setState({
                      current: { ...this.state.current, [property]: e.target.value }
                    })}
                    placeholder={v.capitalize(property)}
                  />
                </div>
              }

              return (
                <div className="col-md-6" key={"property" + index}>
                  {element}
                </div>
              );
            })
          }
        </div>
      </form>
    )
  };

  renderCreator = () => {
    const { creator, bidding } = this.state;
    if (creator && bidding) {
      return (
        <div className="block-content">
          <h4 className="block-content__title">Creator</h4>
          <div className="media user">
            <div className="media-left user-avatar"
                 style={{ backgroundImage: `url(${VarHelper.img(creator.avatar) || defaultImage})` }}>
            </div>
            <div className="media-body">
              <h4 className="media-heading">{creator.name}</h4>
              <p className="user__phone">
                <i className="fa fa-phone-square" aria-hidden="true"> </i> {creator.phone}
              </p>
              <p className="user__email">
                <i className="fa fa-envelope" aria-hidden="true"> </i> {creator.email}
              </p>
              <p className="user__created-date">
                <strong>Created at:</strong> {moment(bidding.createdAt).format('LL')}
              </p>
              <p className="user__update-date">
                <strong>Last update:</strong> {moment(bidding.updatedAt).format('LL')}
              </p>
            </div>
          </div>
        </div>
      )
    }
  };

  renderGeneral = () => {
    const { current } = this.state;
    if (!isEmpty(current)) {
      const {
        toValue,
        toSelectData,
        country, city, district,
        contractor_type,
        project_bidding_scope_name,
        project_bidding_scope_works,
        project_bidding_scope_materials,
      } = this.props.masterStore;

      const data1 = [
        { label: 'End date', value: moment(current.bidCloseTime).format('ll') },
        { label: 'Bid type', value: current.typeOfBid },
        { label: 'Allow alternative bids', value: ['true', true, 'yes', 1, '1'].indexOf(current.allowAlternativeBids) !== -1 ? 'Yes' : 'No' },
        { label: 'Allow sealed bids', value: ['true', true, 'yes', 1, '1'].indexOf(current.allowSealedBids) !== -1 ? 'Yes' : 'No' },
      ];
      const data2 = [
        { label: 'Con-type', value: toValue(contractor_type, current.expectTypeOfContractor) },
        { label: 'Original con', value: toValue(country, current.expectCountryOfContractor) },
        { label: 'Located area', value: toValue(city, current.expectCityOfContractor) },
        { label: '3 year latest revenue', value: current.expectRevenueOfContractor },
        { label: 'Rating', value: 'Upper ' + current.expectRatingOfContractor },
        { label: 'Exp working years', value: 'Min ' + current.expectExperienceContractor + ' years' },
      ];

      const renderDetails = (items) => {
        return items.map((item, index) => {
          return <div key={item.label + index} className="raw-group">
            <span className="key">{ item.label }</span>
            <span className="string"> </span>
            <span className="value">{ item.value }</span>
          </div>
        })
      };

      return (
        <div className="block-content bidding">
          <h4 className="block-content__title">General information</h4>
          <div className="bidding__content">
            {renderDetails(data1)}
            <h5 className="block-content__sub-title">Expected bidder</h5>
            {renderDetails(data2)}
            <h5 className="block-content__sub-title">Other expect</h5>
            <p>{current.expectOtherRequirements}</p>
          </div>
        </div>
      )
    }
  };

  handleRemovePreparation = (e, index, type) => {
    !!e && e.preventDefault();
    let {current} = this.state;
    if (window.confirm("are you sure want to DELETE " + current[type][index]["name"] + "?")) {
      current[type] = current[type].filter((item, idx) => index !== idx);
      this.setState({current});
    }
  };

  handleAddNewItem = (e, type) => {
    !!e && e.preventDefault();
    let { current } = this.state;
    current[type] = current[type] || [];
    const data = {
      id: length + 1,
      name: "New item",
      quantity: 0,
      quantityUnit: "",
      fields: [],
    };
    current[type] = [...current[type], data];
    this.setState({current});
  };

  handleShowUnitsModal = (e, index, type) => {
    !!e && e.preventDefault();
    const {current} = this.state;
    this.setState({unitSelected: {index, type, value: current[type][index]["quantityUnit"]}});
    this.handleOpenModal("units");
  };

  renderPreparationWorks = (type = "works") => {
    const {current, enableEdit} = this.state;

    const getAdditionalFields = (all = false) => {
      let fieldName = [];

      if (!!all) fieldName = ["Tax", "Specification", "Guarantee", "Stock"];

      // (current[type] || []).forEach((item) => {
      //   if (!!item.fields && Array.isArray(item.fields)) {
      //     item.fields.forEach(itm => {
      //       if (!fieldName.includes(itm.name)) fieldName = [...fieldName, itm.name];
      //     })
      //   }
      // });

      return fieldName;
    };

    const renderRows = (items = []) => {
      return items.map((item, index) => {
        return <tr key={type + index}>
          <th scope="row" className="first">{item.id}</th>
          <td>{item.name}</td>
          <td>{item.quantityUnit}</td>
          <td>{item.quantity}</td>
          {renderFieldContent(item.fields)}
        </tr>
      })
    };

    const renderFieldContent = (items = []) => {
      return getAdditionalFields(true).map((item) => {
        let elm = <td key={'td-field-'+item}>-</td>;
        items.forEach(itm => {
          if (itm.name === item && itm.isSelected) {
            elm = <td className="text-success" key={'td-field-'+item}><i className="fa fa-check" aria-hidden="true"> </i></td>
          }
        });
        return elm;
      })
    };

    const renderFieldForm = (items = [], index) => {
      let { current } = this.state;
      return getAdditionalFields(true).map((item) => {
        const filterItem = items.find(itm => itm.name === item) || {};
        return (
          <td className="text-success" key={'td-field-'+item}>
            <div className="form-group" style={{display:'flex', alignItems:'center'}}>
              <div className="custom-control custom-checkbox">
                <input className="custom-control-input" type="checkbox" checked={!!filterItem.isSelected}
                       id={type+index+item}
                       onChange={(e) => {
                         if (!!filterItem && !isEmpty(filterItem)) {
                           items.forEach((data, key) => {
                             if (data.name === item) {
                               current[type][index]["fields"][key]["isSelected"] = e.target.checked;
                             }
                           });
                         } else {
                           current[type][index]["fields"].push({name: item, type: '', isSelected: e.target.checked, isDefault: true});
                         }
                         this.setState({current});
                       }}
                />
                <label htmlFor={type+index+item} className="custom-control-label"> </label>
              </div>
              <select value={filterItem.type || ''} className="form-control"
                      onChange={(e) => {
                        if (!!filterItem && !isEmpty(filterItem)) {
                          items.forEach((data, key) => {
                            if (data.name === item) {
                              current[type][index]["fields"][key]["type"] = e.target.value;
                            }
                          });
                        } else {
                          current[type][index]["fields"].push({name: item, type: e.target.value, isSelected: false, isDefault: true});
                        }
                        this.setState({current});
                      }}
              >
                <option disabled={true} value=""> </option>
                <option value="percentage">Percentage</option>
                <option value="yesno">Yes/No</option>
                <option value="text">Text</option>
              </select>
            </div>
          </td>
        )
      })
    };

    const renderForm = (items = []) => {
      return items.map((item, index) => {
        return <tr key={type + index}>
          <td>
            <button className="btn btn-sm btn-danger" onClick={e => this.handleRemovePreparation(e, index, type)}>Remove</button>
          </td>
          <td><input type="text" value={item.name} className="form-control"
             onChange={(e) => {
               current[type][index] = {...item, name: e.target.value};
               this.setState({current})
             }}
          /></td>
          <td><input type="text" value={item.quantityUnit} className="form-control"
                     style={{cursor:"pointer"}}
                     onChange={(e) => {
                       current[type][index] = {...item, quantityUnit: e.target.value};
                       this.setState({current})
                     }}
                     onClick={(e) => this.handleShowUnitsModal(e, index, type)}
          /></td>
          <td><input type="text" value={item.quantity} className="form-control"
                     onChange={(e) => {
                       current[type][index] = {...item, quantity: e.target.value};
                       this.setState({current})
                     }}
          /></td>
          {renderFieldForm(item.fields, index)}
        </tr>
      })
    };

    return (
      <div className="block-content">
        <h3 className="block-content__title">{type}</h3>
        <p className="text-right">
          Prefer currency: <span className="badge badge-success">{this.state.current.preferredCurrency}</span>
        </p>
        <div className="table-responsive">
          <table className="table">
            <thead>
            <tr>
              <th className="first" scope="col">{enableEdit ? <button className="btn btn-sm btn-primary" onClick={e => this.handleAddNewItem(e, type)}><i className="fa fa-plus"> </i> Add new</button> : '#'}</th>
              <th scope="col">Name</th>
              <th scope="col">quantityUnit</th>
              <th scope="col">quantity</th>
              {getAdditionalFields(true).map(item => <th key={'th-field-'+item}>{item}</th>)}
            </tr>
            </thead>
            <tbody>
            {enableEdit ? renderForm(current[type]) : renderRows(current[type])}
            </tbody>
          </table>
        </div>
      </div>
    )
  };

  renderUploadForm = () => {
    const { current } = this.state;
    return (
      <div className="block-content">
        <div className="block-content__title">
          <span><i className="fa fa-file"> </i> Images & Videos & Documents</span>
        </div>
        <div className="block-content__body">
          {/*images*/}
          <label>Images ({(current.listImages || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control"
                   value={!!current.listImages ? current.listImages.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('image')}>Edit</button>
            </div>
          </div>
          {/*videos*/}
          <label>Videos ({(current.listVideos || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control" placeholder="Video list"
                   value={!!current.listVideos ? current.listVideos.join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('video')}>Edit</button>
            </div>
          </div>
          {/*documents*/}
          <label>Documents ({(current.documents || []).length})</label>
          <div className="input-group" style={{marginBottom:'16px'}}>
            <input type="text" disabled={true} className="form-control"
                   value={!!current.documents ? current.documents.map(item => item.url).join(', ') : ''}
            />
            <div className="input-group-append">
              <button type="button" className="btn btn-danger" onClick={() => this.handleOpenModal('document')}>Edit</button>
            </div>
          </div>
        </div>
      </div>
    )
  };

  handleCloseModal = () => {
    this.setState({
      openVideoModal: false,
      openImageModal: false,
      openDocumentModal: false,
      openUnitsModal: false,
    });
  };

  handleOpenModal = (type) => {
    this.setState({
      openVideoModal: type === 'video',
      openImageModal: type === 'image',
      openDocumentModal: type === 'document',
      openUnitsModal: type === 'units'
    });
  };

  handleSubmitModal = async (data) => {
    let { current, openImageModal, openVideoModal, openDocumentModal, openUnitsModal } = this.state;

    if (openVideoModal) {
      this.setState({ current: {...current, listVideos: [...data]} });
    } else if (openImageModal) {
      this.setState({ current: {...current, listImages: [...data]} });
    } else if (openDocumentModal) {
      this.setState({ current: {...current, documents: [...data]} });
    } else if (openUnitsModal) {
      current[data.type][data.index].quantityUnit = data.value;
      this.setState({unitSelected: {...data}, current});
    }

    this.handleCloseModal();
  };

  render = () => {
    const { current, enableEdit, isSaving, isLoading, openDocumentModal, openImageModal, openVideoModal, openUnitsModal, unitSelected } = this.state;
    const { toValue, project_bidding_scope_name } = this.props.masterStore;
    const { routeStore } = this.props;

    if (isLoading) return (<Loading> </Loading>);

    let content = '';
    let listImages = [];

    if (current.hasOwnProperty('listImages')) {
      const newList = current.listImages.slice();
      for (let i = 0; i < newList.length; i++) {
        const image = newList[i];
        if (image) {
          const item = {
            src: VarHelper.img(image),
            altText: '',
            caption: '',
          };
          listImages.push(item);
        }
      }
    }

    if (enableEdit) {
      content = <div className="card">
        <div className="card-header">
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> Bidding detail: <strong>{toValue(project_bidding_scope_name, current.name)}</strong>

            <Link target="_blank" to={`/project/${current.projectId}`}>
              <span> (project <strong>{current.projectId}</strong>)</span>
            </Link>
          </div>
          <div className="card-header-right">
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {this.renderEditForm()}
            </div>
            <div className="col-md-6">
              {this.renderGeneral()}
              {this.renderUploadForm()}
            </div>
          </div>
          {this.renderPreparationWorks("works")}
          {this.renderPreparationWorks("materials")}
        </div>
        <div className="card-footer">
          <div className="button-group">
            <button className="btn btn-sm btn-primary" disabled={isSaving} onClick={this.saveChanges}>
              <i className="fa fa-dot-circle-o"> </i> { isSaving ? 'Saving' : 'Save' }
            </button>
            <button className="btn btn-sm btn-danger" onClick={this.cancelEdit}>
              <i className="fa fa-ban"> </i> Cancel
            </button>
          </div>
        </div>
      </div>
    } else {
      content = <div className="card">
        <div className="card-header">
          <div className="card-header-left">
            <i className="fa fa-envelope-open"> </i> Bidding detail: <strong>{toValue(project_bidding_scope_name, current.name)}</strong>

            <Link to={routeStore.admin.projectDetail(current.projectId)}>
              <span> (project <strong>{current.projectId}</strong>)</span>
            </Link>
          </div>
          <div className="card-header-right">
            <div className="button-group">
              <button className="btn btn-sm btn-primary" onClick={this.handleEnableEdit}>
                <i className="fa fa-pencil" aria-hidden="true"> </i> Edit
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              {/*images*/}
              <div className="block-content">
                <h3 className="block-content__title">Images ({(listImages || []).length})</h3>
                {listImages.length > 1 ? <Carousel items={listImages}/> : ''}
                {listImages.length === 1 ? <div className="project-detail-image"><img src={listImages[0].src} alt=""/></div> : ''}
              </div>
              {/*documents*/}
              <div className="block-content">
                <h3 className="block-content__title">Documents ({(current.documents || []).length})</h3>
                {(current.documents || []).map((item, index) => <a target="_blank" key={'docs'+index} href={item.url}>document {index + 1}</a>)}
              </div>
              {/*creator*/}
              {this.renderCreator()}
            </div>
            <div className="col-md-6">
              {this.renderGeneral()}
            </div>
          </div>
          {/*preparation works*/}
          {this.renderPreparationWorks("works")}
          {this.renderPreparationWorks("materials")}
        </div>
        <div className="card-footer">
          {this.renderApprove()}
          <button className="btn btn-sm btn-default" onClick={() => this.props.history.goBack()}>
            <i className="fa fa-long-arrow-left"> </i> Go back
          </button>
        </div>
      </div>
    }

    return (
      <div id="bidding-detail" className="animated fadeIn">
        {this.renderApprove()}
        <section>{content}</section>
        <UploadVideoModal
          open={openVideoModal}
          list={current.listVideos || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadVideoModal>
        <UploadImageModal
          open={openImageModal}
          list={current.listImages || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadImageModal>
        <UploadDocumentModal
          open={openDocumentModal}
          list={current.documents || []}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UploadDocumentModal>
        <UnitsModal
          selected={unitSelected}
          open={openUnitsModal}
          onClose={this.handleCloseModal}
          onSubmit={this.handleSubmitModal}
        >
        </UnitsModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Bidding/Detail.js